<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">管理</el-breadcrumb-item>
      <el-breadcrumb-item>首页轮播图管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <el-row :gutter="20" v-if="canLook == 1">
        <el-button @click="addUserDialogVisible = true" type="primary">添加轮播</el-button>
      </el-row>
      <el-table :data="listData" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="图片" prop="pic" width="220px" align="center">
          <template slot-scope="scope">
            <el-image style="width: 200px; height: 100px" :src="scope.row.pic" fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sort" align="center" width="80px"></el-table-column>

        <el-table-column label="是否显示" width="120px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-switch @change="changeUserStated(scope.row)" v-model="scope.row.status"></el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-tooltip :enterable="false" content="编辑" effect="dark" placement="top">
              <el-button @click="edit(scope.row.id)" icon="el-icon-edit" size="mini" type="primary"></el-button>
            </el-tooltip>
            <el-tooltip :enterable="false" content="删除" effect="dark" placement="top">
              <el-button @click="deleteItem(scope.row.id)" icon="el-icon-delete" size="mini" type="danger"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加对话框 -->
    <el-dialog :visible.sync="addUserDialogVisible" @close="addFormClose" title="添加" width="50%">
      <el-form :model="addForm" :rules="addFormRules" label-width="80px" ref="addFormRef">
        <el-form-item label="排序" prop="sort">
          <el-input v-model="addForm.sort"></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="pic">
          <el-upload
            class="upload-demo"
            action="https://hsapi.hsxsn.cn//common/uploads"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="fileUploadSuccess"
            list-type="picture"
            name="images"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传图片</el-button>
            <div slot="tip" class="el-upload__tip">请上传jpg/png文件，且不超过1m，一次上传一张图片</div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span class="dialog-footer" slot="footer">
        <el-button @click="addUserDialogVisible = false">取 消</el-button>
        <el-button @click="addUser" type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑对话框 -->
    <el-dialog :visible.sync="editDialogVisible" @close="editFormClose" title="编辑" width="50%">
      <el-form :model="editForm" :rules="editFormRules" label-width="80px" ref="editFormRef">
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editForm.sort"></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="pic">
          <el-image style="width: 200px; height: 100px" :src="editForm.pic" fit="contain"></el-image>

          <el-upload
            class="upload-demo"
            action="https://hsapi.hsxsn.cn//common/uploads"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :show-file-list="false"
            :on-success="filechangeUploadSuccess"
            list-type="picture"
            name="images"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传图片</el-button>
            <div slot="tip" class="el-upload__tip">请上传jpg/png文件，且不超过1m，一次上传一张图片</div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span class="dialog-footer" slot="footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button @click="sureToedit()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isshow: true, //是否显示
      canLook: 1,
      params: {
        query: '',
        pagenum: 1,
        pagesize: 2,
      },

      listData: [],
      // 添加用户的对话框是否显示
      addUserDialogVisible: false,
      // 添加用户数据
      addForm: {
        pic: '',
        sort: '',
      },

      // 添加的表单校验
      addFormRules: {
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        pic: [{ required: true, message: '请选择图片', trigger: 'blur' }],
      },

      editForm: {
        pic: '',
        sort: '',
      },

      // 编辑用户弹框显示
      editDialogVisible: false,
      // 编辑用户的表单校验
      editFormRules: {
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },

      // 上传的图片
      fileList: [],
    }
  },
  created () {
    this.getLunBoData()
  },

  methods: {
    async getLunBoData () {
      const { data: res } = await this.$http.get('/admin/getlunbo')
      console.log(res.result)
      if (res.code != 200) return this.$message.error('获取轮播数据失败')
      this.listData = res.result
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    // 更新用户的状态
    async changeUserStated (userInfo) {
      const { data: res } = await this.$http.post('/admin/updatelunboStatus', userInfo)
      if (res.code != 200) {
        return this.$message.error('操作失败')
      }
      this.$message.success('操作成功')
      this.getLunBoData()
    },

    // 表单关闭事件
    addFormClose () {
      console.log(this.$refs)
      this.$refs.addFormRef.resetFields()
      this.fileList = [];
      this.isshow = true;
    },

    // 添加轮播
    addUser () {
      this.$refs.addFormRef.validate(async (field) => {
        if (!field) return
        const { data: res } = await this.$http.post('/admin/addlunbo', this.addForm)
        if (res.code != 200) {
          return this.$message.error('添加轮播失败')
        }
        this.$message.success('添加轮播成功')
        this.addUserDialogVisible = false
        this.getLunBoData()

        this.fileList = [];
        this.isshow = true;
        this.$refs.addFormRef.resetFields()
      })
    },

    // 编辑按钮点击
    async edit (userId) {
      const { data: res } = await this.$http.get('/admin/getlunbobyid', {
        params: {
          id: userId,
        },
      })
      console.log(res)
      if (res.code != 200) {
        return this.$message.error('获取信息失败')
      }
      this.editForm = res.result
      this.editDialogVisible = true
    },

    editFormClose () {
      this.editDialogVisible = false
    },

    // 编辑确认
    sureToedit () {
      this.$refs.editFormRef.validate(async (field) => {
        if (!field) return
        const { data: res } = await this.$http.post('/admin/updatelunbo',
          this.editForm
        )
        if (res.code != 200) {
          return this.$message.error('编辑失败')
        }
        this.$message.success('编辑成功')
        this.editDialogVisible = false
        this.getLunBoData()
      })
    },

    //  删除
    async deleteItem (id) {
      console.log(id)
      const result = await this.$confirm(
        '将永久删除该轮播数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      console.log(result)
      if (result == 'confirm') {
        const { data: res } = await this.$http.post('/admin/deletelunbo', { id: id })
        if (res.code != 200) {
          return this.$message.error('删除失败')
        }
        this.$message.success('删除成功')
        this.getLunBoData()
      } else {
        return this.$message.info('删除已取消')
      }
    },

    //图片上传
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },

    handlePreview (file) {
      console.log(file)
    },

    fileUploadSuccess (response, file, fileList) {
      console.log(response.result.show, file, fileList)
      this.addForm.pic = response.result.show
    },

    filechangeUploadSuccess (response, file, fileList) {
      console.log(response.result.show)
      this.editForm.pic = response.result.show
    },

    //是否显示
    isshowchange (res) {
      this.isshow = res
      this.addForm.type = this.isshow == true ? 1 : 0
    },

    //列表的显示设置
    async listSwitchchange (info) {
      console.log(info)
      const { data: res } = await this.$http.post('updatelunboShow', {
        id: info.id,
        type: info.type,
      })
      if (res.code != 200) {
        return this.$message.error('更新状态失败')
      }
      return this.$message.success('更新状态成功')
    },
  },
}
</script>

<style lang="less" scoped></style>
